export enum SortDirection {
  asc = 'Asc',
  desc = 'Desc',
}
